const MARKER = "checkoutV2CartDrawer";
let sequence = 0;
const pathOf = (location) => `${location.pathname}${location.search || ""}${location.hash || ""}`;

// Give an inline drawer its own same-page entry. Back dismisses the overlay,
// even when the shopper entered this page directly from another website.
export default class CartDrawerHistory {
  constructor(history, onBack, onForward, scope = "inline") {
    this.history = history;
    this.onBack = onBack;
    this.onForward = onForward;
    this.scope = scope;
    const existing = history.location.state?.[MARKER];
    if (existing?.path === pathOf(history.location) && this.matchesScope(existing)) {
      this.id = existing.id;
      this.active = true;
    }
    this.unlisten = history.listen((location, action) => {
      const ownsEntry = this.owns(location);
      if (this.afterBack && !ownsEntry) {
        const callback = this.afterBack;
        this.afterBack = null;
        this.active = false;
        callback();
      } else if (action === "POP" && this.active && !ownsEntry) {
        this.active = false;
        this.onBack();
      } else if (action === "POP" && !this.active && ownsEntry) {
        this.active = true;
        this.onForward();
      }
    });
  }

  matchesScope = (marker) => (marker?.scope || "inline") === this.scope;

  owns = (location = this.history.location) =>
    Boolean(this.id && location.state?.[MARKER]?.id === this.id);

  open() {
    const location = this.history.location;
    const existing = location.state?.[MARKER];
    // A reload already has a drawer entry: do not accumulate another one.
    if (existing?.path === pathOf(location) && this.matchesScope(existing)) {
      this.id = existing.id;
      this.active = true;
      return;
    }
    this.id = `cart-${Date.now()}-${++sequence}`;
    this.active = true;
    this.history.push({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: { ...location.state, [MARKER]: { id: this.id, path: pathOf(location), scope: this.scope } },
    });
  }

  close(callback) {
    if (!this.owns()) {
      this.active = false;
      callback();
      return;
    }
    // Only go back over the entry we created, never over unknown history.
    this.afterBack = callback;
    this.history.goBack();
  }

  dispose() {
    this.unlisten();
    this.afterBack = null;
  }
}
